import LinearGradient from "./LinearGradient.js";
/**
 * All props pass through to `<LinearGradient {...props} />`
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function GradientPurpleTeal(_ref) {
  let {
    from = '#5B247A',
    to = '#1BCEDF',
    ...restProps
  } = _ref;
  return /*#__PURE__*/_jsx(LinearGradient, {
    from: from,
    to: to,
    ...restProps
  });
}